export const m = {
  // 操作提示
  selectFileTip: "请选择文件",
  selectIncorrectTip: "请选择正确的",
  incorrectTip: "请输入正确的",
  emptyTip: "不能为空",
  editTip: "修改成功",
  createdTip: "创建成功",
  secondPsdDifferentTip: "密码与确认密码不一致",
  deleteConfirmTip: "确定删除",
  deletedTip: "删除成功",
  uploadedTip: "上传成功",
  savedTip: "保存成功",
  searchTip: "搜索",
  dataException: "数据异常",
  // 校验规则
  passwordErrorTip: "密码至少8位，且必须包含数字、大小写字母和特殊字符",
  greaterThanZeroTip: "必须>0",
  betweenZeroAndOneHundredTip: "必须>=0且<=100",
  betweenZeroAndOneTip: "必须>0且<1",
  greaterThanZeroInteger: "为整数且>0",
  nameLengthLimit: "名字的长度不能>12",
  MPANLengthLimit: "的长度为13位或21位",
  numbersLettersUnderLineLimit: "仅限输入数字、字母、_",
  numbersLettersHorizontalLineLimit: "仅限输入数字、字母、-",
  gunSortLimit: "充电枪排序>0且<枪的个数，且不能重复",
  gunNameLimit: "充电枪名字长度不能>2",
  // 按钮
  cancelBtn: "取消",
  confirmBtn: "确定",
  createBtn: "创建",
  nextBtn: "下一步",
  // 登录页面
  loginTip: "请登录您的账户",
  email: "邮箱",
  password: "密码",
  signIn: "登录",
  login: "登录",
  forgetPsd: "忘记密码",
  securityCode: "验证码",
  verfication: "验证",
  send: "发送",
  loginNewPsd: "新密码",
  confirmNewPsd: "确认新密码",
  return: "返回",
  emailErrorTip: "请输入正确的邮箱",
  // 首页
  sites: "站点",
  // 联系客服提示
  allFuncTip:
    "感谢您的体验，如果您想使⽤全部功能，可以联系我们，或者填写您的邮箱，我们会尽快与您联系",
  ourContact: "我们的联系方式",
  yourEmail: "您的邮箱",
  submit: "提交",
  remark: "备注",
  // 新用户导航提示
  createAssetTitleTip: "点击这⾥，可以快速创建模拟资产哦。",
  createAssetTip:
    "(模拟资产并不会产⽣真实的采集数据，如果你想体验全部功能，请联系我们：info@xrenewable.com)",
  paramEditTitleTip:
    "点击这⾥，选择“⾃定义参数⼯具”可以为你创建的模拟资产进⾏Tariff配置哦。",
  paramEditTip:
    "(⾃定义的Tariff数据仅供参考，如果你想体验全部功能，请联系我们：info@xrenewable.com)",
  scheduleEditTitleTip: "点击这⾥，可以为资产配置调度计划，配置⼯单。",
  scheduleEditTip:
    "(模拟的资产暂时不提供该功能，如果你想体验全部功能，请联系我们：info@xrenewable.com)",
  assetOperationTitleTip:
    "点击这⾥，可以了解资产的运维信息，包括报警，⼯单等数据的统计。",
  assetOperationTip:
    "(模拟的资产暂时不提供该功能，如果你想体验全部功能，请联系我们：info@xrenewable.com)",
  prev: "上⼀步",
  next: "下⼀步",
  alreadyKnow: "我已了解",
  my: "账单",
  assets: "站点",
  // 用户功能
  funcUserInfo: "个人信息",
  funcChangePsd: "修改密码",
  funcLoginOut: "退出登录",
  funcManageChannel: "渠道商管理",
  funcManageUser: "用户管理",
  setUserInfo: "个人信息设置",
  userName: "用户名",
  userPhone: "联系方式",
  userRemark: "备注信息",
  setSaveBtn: "保存",
  changePsdTitle: "修改密码",
  originPsd: "原密码",
  newPsd: "新密码",
  confirmPsd: "确认新密码",
  // 站点数据
  dashboard: "数据",
  liveMonitor: "实时监视器",
  Configuration: "配置",
  // 站点编辑
  siteScene: "场景类型",
  siteAdd: "新增站点",
  siteEdit: "编辑站点",
  assetAdd: "新增资产",
  assetEdit: "编辑资产",
  assetType: "资产类型",
  assetPVEdit: "编辑光伏资产",
  assetESEdit: "编辑储能资产",
  assetLoadEdit: "编辑负荷",
  assetPVAdd: "光伏",
  assetESAdd: "储能",
  assetLoadAdd: "负荷",
  assetPV: "光伏资产",
  assetES: "储能",
  assetLoad: "负荷",
  energyStorage: "储能",
  photovoltaic: "光伏",
  load: "负荷",
  siteName: "站点名称",
  siteType: "站点类型",
  owner: "业主",
  longitude: "经度",
  latitude: "纬度",
  longitudeAndLatitude: "经纬度",
  timeZone: "时区",
  powerSupplier: "电力供应商",
  maxImportCapacity: "最大输入容量",
  maxExportCapacity: "最大输出容量",
  SEGUnitRate: "上网电价",
  tariffPeriod: "用电价格",
  siteAddress: "站点所在地址",
  importMPAN: "用电MPAN",
  exportMPAN: "卖电MPAN",
  importMPRN: "用电MPRN",
  exportMPRN: "卖电MPRN",
  applicationType: "应用类型",
  cannotRepeatTip: "不能重复",
  MPAN: "MPAN",
  MPRN: "MPRN",
  alias: "别名",
  capacity: "容量",
  wholeSale: "WholeSale",
  // 资产页面
  schedulePredictionTime: "预测时间",
  setAssetParam: "调整资产参数",
  setAssetTariff: "调整电价",
  setAssetSchedule: "调整维修",
  all: "全部",
  assetName: "名称",
  installedCapacity: "装机容量",
  assetStatus: "状态",
  ratedPower: "额定功率",
  distance: "距离",
  expectedIncome: "预期收入",
  dailyCycle: "预测日循环",
  emptyDataTip: "暂无数据",
  today: "日前预测",
  tomorrow: "日内数据",
  data: "数据",
  view: "显示",
  power: "功率",
  unitRatedPower: "单位额定功率",
  pvPanelNum: "光伏板数量",
  totalRatedPower: "总额定功率",
  firstYearAttenuation: "首年衰减",
  linearAttenuationRate: "线性衰减率",
  loadAssetType: "负荷类型",
  pvPowerGeneration: "光伏发电量",
  Solar: "太阳能",
  Battery: "储能",
  Grid: "电网",
  selfConsumption: "自用",
  bess: "储能",
  grid: "电网",
  estimatedLoad: "用电量",
  energyStorageChargeAndDischarge: "储能调度电量",
  photovoltaicCharging: "光伏充入",
  gridCharging: "电网充入",
  putItIntoElectricity: "放入电网",
  feederNetwork: "放入负荷",
  day: "日",
  night: "夜",
  todayText: "今天",
  backToday: "返回今天",
  limitAssetNumTip: "请至少添加一个资产",
  chargingPower: "充电功率",
  // 充电桩信息
  chargingPile: "充电桩",
  chargingPileConnectors: "连接器数量",
  chargingPileTariffPeriod: "充电电价",
  chargingPileNo: "编号",
  chargingPilePower: "功率",
  // powermodule
  ACDC: "AC/DC",
  chargingDCDC: "Charging DC/DC",
  PVDCDC: "PV DC/DC",
  batteryDCDC: "Battery DC/DC",
  // 流向图
  importAndExportMeter: "单仪表输入输出",
  importOnly: "仅输入",
  importAndExport: "输入输出",
  exportOnly: "仅输出",
  solorToGridDirectly: "太阳能直接并网",
  totalImportFromGrid: "电网总输入",
  totalExportFromGrid: "电网总输出",
  loadMetFromSolar: "太阳能负载",
  bessChargeFromSolar: "太阳能充电",
  loadMetFromGrid: "电网负载",
  bessChargeFromGrid: "电网充电",
  bessDischargeToGrid: "电网放电",
  bessDischargeToLoad: "负荷放电",
  meter1: "仪表1",
  meter2: "仪表2",
  meter1Text: "仪表1：输入输出",
  // 算法数据
  charge: "充电",
  discharge: "放电",
  ffr: "辅助市场服务",
  outage: "维修",
  standby: "待机",
  soc: "电量",
  batteryCapacity: "电池容量",
  tariff: "电价",
  startSOC: "初始电量",
  endSOC: "结束电量",
  normalInfo: "基本信息",
  schedule: "调度计划表",
  schedulingCalendar: "调度日历",
  operationInfo: "运维信息",
  map: "地图",
  alarmData: "报警统计",
  // 资产参数
  serialNumber: "硬件设备序列号",
  equipmentManufacturer: "设备制造商",
  omOperator: "O&M运营⽅",
  assetOwner: "资产业主",
  assetNo: "资产编号",
  country: "选择国家",
  area: "选择地域",
  address: "资产所在地址",
  assetLongitude: "资产经度",
  assetLatitude: "资产纬度",
  assetTimezone: "资产时区",
  voltage: "电压",
  dno: "配电⽹公司",
  type: "类型",
  projectApplicationCategory: "项⽬应⽤类别",
  cycleEfficiency: "充放电效率",
  warrantyPeriod: "质保年限",
  attenuationCurve: "SOH",
  lifeCycleCycles: "⽣命周期循环次数",
  temperature: "⼯作温度",
  maxTemperature: "最大工作温度",
  minTemperature: "最小工作温度",
  coolingTime: "充放电冷却时间",
  minDayCycles: "最⼩⽇循环次数",
  maxDayCycles: "最⼤⽇循环次数",
  minYearCycles: "最⼩年循环次数",
  maxYearCycles: "最⼤年循环次数",
  operationTime: "投运时间",
  operationStatus: "运营状态",
  notBuilt: "未建成",
  built: "已建成",
  inOperation: "已正式商业运营",
  unitYear: "年",
  pileName: "充电桩名称",
  pileNo: "充电桩编号",
  pileManufacturer: "充电桩制造商",
  pileSerialNo: "充电桩序列号",
  gunNo: "充电枪编号",
  gunSerialNumber: "充电枪序列号",
  gunPower: "充电枪功率",
  gunSort: "充电枪排序",
  rateACDC: "RATE AC/DC",
  rateDCDC: "RATE DC/DC",
  RTE: "RTE",
  // 辅助市场服务实时数据页
  frequency: "频率",
  actualPower: "实际功率",
  targetPower: "目标功率",
  currentTime: "当前时间",
  targetTotalPower: "目标累计电量",
  actualTotalPower: "累计电量",
  powerScheduleEfficiency: "功率调度效能",
  batteryScheduleEfficiency: "电量调度效能",
  outaging: "正在维修中...",
  pvEnergy: "光伏发电量",
  batteryChargeEnergy: "储能充电量",
  batteryDischargeEnergy: "储能放电量",
  loadEnergy: "负荷用电量",
  pvPower: "光伏功率",
  batteryPower: "电池功率",
  loadPower: "负荷功率",
  globalRadiation: "太阳辐射",
  cloud: "云层",
  weatherTemperature: "温度",
  // 账单页
  no: "编号",
  estimatedAccount: "估算账单",
  detail: "明细",
  MonthlyAccountdetail: "账单月明细",
  contractEstimate: "合同估算",
  deviation: "偏差",
  actualIncome: "实际收入",
  total: "总计",
  date: "日期",
  amountOfMoney: "金额",
  dailyAccountdetail: "账单日明细",
  estimatedIncome: "预期收入",
  uploadMonthlyAccount: "上传月账单",
  downloadMonthlyAccount: "下载月账单",
  selectFile: "选择文件",
  estimatedSOC: "估算SOC",
  actualSOC: "真实SOC",
  tariffSelect: "电价选择",
  profileType: "电表类型",
  lineLossFactor: "线损系数",
  distributor: "经销商",
  workorderCreate: "创建⼯单",
  scheduleCreate: "创建调度计划",
  tool: "⼯具",
  ffrMode: "选择辅助市场服务模式",
  availabilityPrice: "可⽤价格",
  utilisationPrice: "使⽤价格",
  selectWorkDay: "选择服务⽇",
  selectTime: "选择时间",
  EstimatedRevenue: "预估收益",
  saveSetting: "保存设置",
  isDeleteSchedule: "是否要删除该调度计划",
  gained: "已收益",
  urealisedBenefits: "未实现收益",
  investment: "投资",
  tenYearsExpectGained: "生命周期预期收益",
  returnOfInvestment: "投资回报",
  expectGained: "预期收入",
  month: "月",
  year: "年",
  totalSingle: "总",
  fromInstall: "自安装起",
  electricitySaving: "自发自用收益",
  PowerGenerationIncome: "发电上网收益",
  revenue: "总收益",
  monthlySaving: "月节约",
  monthlyElectricitySaving: "月节约电费",
  monthlyPowerGenerationIncome: "收益",
  annualSaving: "年节约",
  annualElectricitySaving: "年节约电费",
  annualPowerGenerationIncome: "收益",
  totalSaving: "总节约",
  totalElectricitySaving: "总节约电费",
  totalPowerGenerationIncome: "总发电上网收益",
  recovered: "已收回",
  totalInvestment: "总投资额",
  saved: "已节约",
  estimatedSavings: "预计节约",
  // 资产设置单页面
  selectTariff: "选择电价",
  selectDate: "选择日期",
  mode: "模式",
  timeRange: "时间段",
  keepSOC: "保持SOC",
  kWh: "kWh",
  startTime: "开始时间",
  endTime: "结束时间",
  auto: "自动",
  resetBtn: "恢复默认",
  viewBtn: "预览",
  timeRepeatTip: "时间选择重复",
  dailyCycleFaultTip: "最大日循环次数不能小于最小日循环次数",
  cycleEfficiencyFaultTip: "请输入正确的充放电效率",
  // 调度计划页面
  viewSchedule: "查看调度计划",
  createSchedule: "查看调度计划",
  scheduleList: "计划列表",
  time: "时间",
  // 用户管理
  userManage: "用户管理",
  user: "用户",
  delete: "删除",
  userList: "用户列表",
  name: "姓名",
  phone: "电话",
  channel: "渠道",
  role: "角色",
  operate: "操作",
  edit: "编辑",
  userInfo: "用户信息",
  confirmPassword: "确认密码",
  limitSelectTip: "请至少选择一个",
  // 渠道商管理
  channelManage: "渠道商管理",
  channelProvider: "渠道商",
  channelList: "渠道商列表",
  channelName: "渠道商名称",
  areaName: "区域",
  contactName: "联系人",
  relateSite: "关联站点",
  sitePool: "站点池",
  relateSuccessTip: "关联成功",
  channelUser: "渠道商普通用户",
  channelAdmin: "渠道商管理员",
  // 账单管理
  billManage: "账单管理",
  billList: "账单列表",
  bill: "账单",
  statementDate: "报表日期",
  billType: "账单类型",
  billName: "账单名称",
  uploadDate: "上传日期",
  uploadBill: "上传账单"
};
